import { render, staticRenderFns } from "./EzCategoryDropdown.vue?vue&type=template&id=4d8503a3&scoped=true&"
import script from "./EzCategoryDropdown.vue?vue&type=script&lang=js&"
export * from "./EzCategoryDropdown.vue?vue&type=script&lang=js&"
import style0 from "./EzCategoryDropdown.vue?vue&type=style&index=0&id=4d8503a3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8503a3",
  null
  
)

export default component.exports